module.exports = __webpack_public_path__ + "static/media/BabyCourse_Mobile_7.63c91e3a.jpf";